/**
 * state of the shop
 */
const state = {
    DEFAULT_IMAGE_SRC: '', // require(''),
    NO_IMAGE_SRC: '', // require(''),
    BUILD_NUMBER: 'V1.0'
}

export default {
    state
}



// WEBPACK FOOTER //
// ./src/store/modules/constants.js